import httpClient, { buildQueryString } from "./httpClient";

const defaultRequest = (...args) => httpClient.request(...args);

export const getCustomers = (params = {}, request = defaultRequest) =>
  request(`/v1/dashboard/customers${buildQueryString(params)}`);

export const getCustomer = (customerId, request = defaultRequest) =>
  request(`/v1/dashboard/customers/${encodeURIComponent(customerId)}`);

export const createCustomer = (customerData, request = defaultRequest) =>
  request("/v1/dashboard/customers", {
    method: "POST",
    body: JSON.stringify(customerData),
  });

export const updateCustomer = (customerId, data, request = defaultRequest) =>
  request(`/v1/dashboard/customers/${encodeURIComponent(customerId)}`, {
    method: "PATCH",
    body: JSON.stringify(data),
  });

export const setCustomerSuspension = (
  customerId,
  suspend,
  request = defaultRequest
) =>
  request(`/v1/dashboard/customers/${encodeURIComponent(customerId)}/suspend`, {
    method: "PATCH",
    body: JSON.stringify({ suspend }),
  });

export const updateCustomerResellerStatus = (
  customerId,
  { isReseller, resellerType },
  request = defaultRequest
) => {
  const body = { isReseller };

  if (resellerType) {
    body.resellerType = resellerType;
  }

  return request(
    `/v1/dashboard/customers/${encodeURIComponent(customerId)}/reseller`,
    {
      method: "PATCH",
      body: JSON.stringify(body),
    }
  );
};

export const getCustomerAuditLog = (
  customerId,
  params = {},
  request = defaultRequest
) =>
  request(
    `/v1/dashboard/customers/${encodeURIComponent(customerId)}/audit-log${buildQueryString(params)}`
  );

export const getCustomerNotes = (customerId, request = defaultRequest) =>
  request(`/v1/dashboard/customers/${encodeURIComponent(customerId)}/notes`);

export const createCustomerNote = (
  customerId,
  { message },
  request = defaultRequest
) =>
  request(`/v1/dashboard/customers/${encodeURIComponent(customerId)}/notes`, {
    method: "POST",
    body: JSON.stringify({ message }),
  });

export const updateCustomerNote = (
  customerId,
  noteId,
  { message },
  request = defaultRequest
) =>
  request(
    `/v1/dashboard/customers/${encodeURIComponent(customerId)}/notes/${encodeURIComponent(noteId)}`,
    {
      method: "PATCH",
      body: JSON.stringify({ message }),
    }
  );

export const deleteCustomerNote = (
  customerId,
  noteId,
  request = defaultRequest
) =>
  request(
    `/v1/dashboard/customers/${encodeURIComponent(customerId)}/notes/${encodeURIComponent(noteId)}`,
    {
      method: "DELETE",
    }
  );
